import { useMissionConfig } from "@/composables/missions/useMissionConfig";

/**
 * Helper function to check if any of the provided mission codes are active
 * @param {string[]} codes - Array of mission codes to check
 * @returns {boolean} - True if any of the codes are active
 */
export const checkActiveMissionsCodesIncludes = (codes) => {
  const { selectedElementaryMissions } = useMissionConfig();
  return codes.some((code) => selectedElementaryMissions.value.includes(code));
};

/**
 * Mission code constants for interpretation components
 */
export const INTERPRETATION_MISSION_CODES = {
  SOILS: "A200",
  GROUNDWATER: "A210",
  SURFACE_WATER_SEDIMENTS: "A220",
  SOIL_GAS: "A230",
  AMBIENT_AIR: "A240",
  FOOD_PRODUCTS: "A250",
  EXCAVATED_SOIL: "A260",
};
